export default __webpack_public_path__ + "static/media/ir.91abd914.svg";